import AreaIcon from '@apps-common/ui-icons/Area.jsx';
import {
  Timeline as TimelineIcon,
  Warning as WarningIcon,
} from '@mui/icons-material';
import {
  Box,
  Checkbox,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Tooltip,
  Typography,
} from '@mui/material';
import {bool, func, object, string} from 'prop-types';
import React from 'react';

import {formatArea} from './format.js';

const FeatureListItem = ({
  description,
  feature,
  id,
  label,
  onChange,
  selected,
}) => (
  <ListItemButton
    role={undefined}
    onClick={onChange}
    dense
    divider
    selected={selected}
    sx={{
      flexDirection: 'column',
      alignItems: 'end',
      borderColor: 'rgba(255, 255, 255, 0.25)',
    }}
  >
    <Box sx={{display: 'flex', alignItems: 'center', width: '100%'}}>
      <ListItemIcon
        sx={{
          minWidth: theme => theme.spacing(4),
        }}
      >
        <Checkbox
          edge="start"
          tabIndex={-1}
          disableRipple
          checked={selected}
          onChange={onChange}
        />
      </ListItemIcon>

      <ListItemText disableTypography>
        <Box sx={{display: 'flex', alignItems: 'center'}}>
          <Typography variant="body2" title={label}>
            {label}
          </Typography>
          {!feature.pl_metadata.is_clean && (
            <Box
              sx={{
                marginLeft: 'auto',
              }}
            >
              <Tooltip title="Feature will require simplification">
                <WarningIcon color="warning" fontSize="small" />
              </Tooltip>
            </Box>
          )}
        </Box>
        {id && (
          <Typography
            variant="caption"
            sx={{
              display: 'block',
            }}
          >
            <i>id</i>: {id}
          </Typography>
        )}
        <Typography
          variant="caption"
          sx={{
            display: 'block',
          }}
        >
          <i>description</i>:&nbsp;
          <Typography
            variant="inherit"
            sx={{
              display: 'inline',
              color: description ? 'text.primary' : 'text.secondary',
            }}
          >
            {description || 'No description'}
          </Typography>
        </Typography>
      </ListItemText>
    </Box>
    <Stack
      direction="row"
      sx={{
        justifyContent: 'space-between',
        width: '100%',
      }}
    >
      <Typography
        variant="caption"
        component="div"
        sx={{display: 'flex', alignItems: 'center', fontFamily: 'monospace'}}
      >
        <TimelineIcon
          fontSize="small"
          sx={{marginRight: 0.5}}
          color="action"
          data-testid="vertexCountIcon"
        />
        {`${feature.pl_metadata.vertex_count} vertices`}
      </Typography>

      <Typography
        variant="caption"
        component="div"
        sx={{display: 'flex', alignItems: 'center', fontFamily: 'monospace'}}
      >
        <AreaIcon
          fontSize="small"
          sx={{fontSize: 18, marginRight: 0.5}}
          color="action"
          data-testid="areaIcon"
        />

        {formatArea(feature.pl_metadata.area)}
      </Typography>
    </Stack>
  </ListItemButton>
);

FeatureListItem.propTypes = {
  description: string,
  feature: object,
  id: string,
  label: string,
  onChange: func,
  selected: bool,
};

export default FeatureListItem;
